import { render, staticRenderFns } from "./Pivot2.vue?vue&type=template&id=8687fcba&scoped=true&"
import script from "./Pivot2.vue?vue&type=script&lang=js&"
export * from "./Pivot2.vue?vue&type=script&lang=js&"
import style0 from "./Pivot2.vue?vue&type=style&index=0&id=8687fcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8687fcba",
  null
  
)

export default component.exports